'use client'
import Rating from 'components/Rating/Rating'
import { Typography } from 'components/Typography'
import { LinkButton } from 'components/Contentful'
import { Image } from 'components/Image'

const TrustpilotRatingBadge = ({
  rating = 0,
  totalReviews = 0,
  outOf = 5,
  color,
  link,
  onReviewClick = () => {},
}) => {
  const totalReviewsString = totalReviews.toLocaleString('en-US')

  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center">
        <Image
          src="/multi-site-assets/trustpilot.svg"
          height={24}
          width={88}
          alt="trustpilot"
          priority
        />
        <div className="mx-2">
          <Rating
            rating={rating}
            totalStars={outOf}
            totalReviews={totalReviews}
            filledStarColor={color}
          />
        </div>
        <Typography className="text-[12px] lg:text-[14px] leading-[1.4]" component="span">
          {rating}/{outOf}
        </Typography>
      </div>
      <Typography component="p" className="mt-2">
        <strong className="text-[12px] leading-[1.4] text-neutral-900 lg:text-[14px]">
          Excellent •{' '}
        </strong>
        <LinkButton
          className="p-0 h-auto min-h-auto"
          content={{
            linkText: `${totalReviewsString}+ reviews`,
            linkHref: link,
          }}
          variant="text"
          onClick={onReviewClick}
          target="_blank"
          track={{
            event_action: 'button_click',
            event_type: 'track',
            click_id: 'Trustpilot',
            click_text: totalReviewsString,
            click_type: 'Link Click',
            nav_link_section: 'Hero Card',
            page_section: 'Our clients say it best',
            event_name: 'FDR-Web | Reviews - Continue Clicked',
            click_url: link,
            track_event: 'internal_campaign_click',
          }}
          typographicOptions={{
            className: 'text-[12px] leading-[1.4] text-neutral-900 lg:text-[14px]',
          }}
        />
      </Typography>
    </div>
  )
}

export default TrustpilotRatingBadge
